var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 76,
  height: 76,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m36.77 39.283-4.518 4.519 4.519 4.519 4.519-4.52-4.52-4.518ZM36.772 57.304v-9.038",
  stroke: "#5758FF",
  strokeWidth: 1.436,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m15.683 36.217 21.088-12.05 21.088 12.05v24.1L36.77 72.367l-21.088-12.05v-24.1Z",
  stroke: "#5758FF",
  strokeWidth: 1.436,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M51.834 32.773V11.685L36.77 3.078l-15.063 8.607v21.088",
  stroke: "#5758FF",
  strokeWidth: 1.436,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgLock as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzYiIGhlaWdodD0iNzYiIHZpZXdCb3g9IjAgMCA3NiA3NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM2Ljc3MDggMzkuMjgzTDMyLjI1MiA0My44MDE4TDM2Ljc3MDggNDguMzIwN0w0MS4yODk3IDQzLjgwMThMMzYuNzcwOCAzOS4yODNaIiBzdHJva2U9IiM1NzU4RkYiIHN0cm9rZS13aWR0aD0iMS40MzU1NiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTM2Ljc3MTUgNTcuMzA0MVY0OC4yNjY0IiBzdHJva2U9IiM1NzU4RkYiIHN0cm9rZS13aWR0aD0iMS40MzU1NiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE1LjY4MjYgMzYuMjE2NUwzNi43NzA2IDI0LjE2NjJMNTcuODU4NiAzNi4yMTY1VjYwLjMxN0wzNi43NzA2IDcyLjM2NzNMMTUuNjgyNiA2MC4zMTdWMzYuMjE2NVoiIHN0cm9rZT0iIzU3NThGRiIgc3Ryb2tlLXdpZHRoPSIxLjQzNTU2IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNTEuODMzNyAzMi43NzI5VjExLjY4NDlMMzYuNzcwOSAzLjA3Nzk0TDIxLjcwOCAxMS42ODQ5VjMyLjc3MjkiIHN0cm9rZT0iIzU3NThGRiIgc3Ryb2tlLXdpZHRoPSIxLjQzNTU2IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";